import React, { useState, useEffect } from "react";
import { useStaticQuery, graphql, Link } from "gatsby";

import Img from "gatsby-image";
import { renderStatic } from "react-helmet";
// import ContactForm from "./ContactForm";

const ChildPages = (props) => {
  console.log("my daddy", props.forParent);
  const { allWordpressPage } = useStaticQuery(
    graphql`
      query ChildQuery {
        allWordpressPage {
          edges {
            node {
              title
              slug
              type
              id
              wordpress_parent
              wordpress_id
              content
            }
          }
        }
      }
    `
  );

  return (
    <>
      {allWordpressPage.edges.map(({ node }) => {
        if (node.wordpress_parent === props.forParent) {
          return (
            <div className="container container--page">
              <h2 dangerouslySetInnerHTML={{ __html: node.title }} />

              <div dangerouslySetInnerHTML={{ __html: node.content }}></div>
            </div>
          );
        }
      })}
    </>
  );
};

export default ChildPages;
